import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem('UserId');
    setIsAuthenticated(!!userId); // Check if the user is authenticated
  }, []);

  const login = (userData) => {
    localStorage.setItem('UserName', userData.UserName);
    localStorage.setItem('UserId', userData.UserID);
    localStorage.setItem('CmpGUID', userData.CmpGUID);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('UserName');
    localStorage.removeItem('UserId');
    localStorage.removeItem('CmpGUID');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
